import { Nilable } from "@shared/utils";


export interface IPiramidePoblacionalDTO{
    id: number;
    country: string;
    age_range: string;
    gender: string;
    population: number;
}

export class PiramidePoblacionalDTO {
    public id = 0;
    public pais = "";
    public rangoEdad = "";
    public genero = "";
    public poblacion = 0;

    constructor(json: Nilable<Partial<IPiramidePoblacionalDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPiramidePoblacionalDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.country != null) {
            this.pais = json.country;
        }
        if (json.age_range != null) {
            this.rangoEdad = json.age_range;
        }
        if (json.gender != null) {
            this.genero = json.gender;
        }
        if (json.population != null) {
            this.poblacion = json.population;
        }
    }

    public toJSON(): IPiramidePoblacionalDTO {
        return {
            id: this.id,
            country: this.pais,
            age_range: this.rangoEdad,
            gender: this.genero,
            population: this.poblacion
        };
    }
}
